import React from 'react';

const SelectTabContext = React.createContext();

export default SelectTabContext;
